import { Edit2 } from "lucide-react";


export const getCountryClauseColumns = (handlers) => {
  const { handleEdit } = handlers;

  return [
    {
      key: "country",
      label: "COUNTRY",
      render: (v) => v?.country || "-"
    },
    {
      key: "countryCode",
      label: "COUNTRY ISO CODE",
      render: (v) => v?.countryCode || "-"
    },
    {
      key: "countryClause",
      label: "COUNTRY CLAUSE",
      render: (v) => v?.countryClause || "-"
    },
    {
      key: "action",
      label: "ACTION",
      render: (v) => (
        <div className="flex items-center gap-3">
         <button
            onClick={() => handleEdit(v)}
                className="w-6 h-6 rounded flex items-center justify-center transition-all bg-blue-100 text-blue-700 hover:bg-blue-200 "
            title="Edit"
          >
            <Edit2 size={16} />
          </button>
        </div>
      )
    }
  ];
};